(() => {
  'use strict'
  // Disabled intentionally: do not monkeypatch window.fetch on the storefront.
})()
